import userRoleNames from '../../consts/auth/userRoleNames';
import {IAP_FEATURES_CODES} from '../../consts/iap/iapFeatureCodes';

// Copy from IAP
export default {
    [userRoleNames.NEXTGEN]: [
        IAP_FEATURES_CODES.ABOUT_DEVICE,
        IAP_FEATURES_CODES.LOCATION,
        IAP_FEATURES_CODES.ADVANCED_DIAGNOSTIC,
        IAP_FEATURES_CODES.ADVANCED_DIAGNOSTIC_PHASE_2,
        IAP_FEATURES_CODES.AI_ASSISTANT,
        IAP_FEATURES_CODES.APPEARANCE,
        IAP_FEATURES_CODES.AUTO_START,
        IAP_FEATURES_CODES.CONNECTIVITY,
        IAP_FEATURES_CODES.DEVICE_LOCK,
        IAP_FEATURES_CODES.EXPERIENCE_SCORE,
        IAP_FEATURES_CODES.FLEX_BATTERY,
        IAP_FEATURES_CODES.FLEX_PUFF,
        IAP_FEATURES_CODES.LED_INTENSITY,
        IAP_FEATURES_CODES.PAUSE_MODE,
        IAP_FEATURES_CODES.RANGE_MODE,
        IAP_FEATURES_CODES.REMEMBER_HEATING_PROFILE,
        IAP_FEATURES_CODES.SETUP,
        IAP_FEATURES_CODES.SIDEWALK,
        IAP_FEATURES_CODES.SMART_GESTURES,
        IAP_FEATURES_CODES.SOFTWARE_UPDATE,
        IAP_FEATURES_CODES.SWITCH_MASTER_BADGE,
        IAP_FEATURES_CODES.TIPS_AND_TUTORIALS,
        IAP_FEATURES_CODES.TUNABILITY,
        IAP_FEATURES_CODES.USAGE,
        IAP_FEATURES_CODES.VIBRATION,
        IAP_FEATURES_CODES.VIBRATION_INTENSITY,
    ],
    [userRoleNames.RETAIL_OPERATOR]: [
        IAP_FEATURES_CODES.ABOUT_DEVICE,
        IAP_FEATURES_CODES.LOCATION,
        IAP_FEATURES_CODES.ADVANCED_DIAGNOSTIC,
        IAP_FEATURES_CODES.ADVANCED_DIAGNOSTIC_PHASE_2,
        IAP_FEATURES_CODES.APPEARANCE,
        IAP_FEATURES_CODES.AUTO_START,
        IAP_FEATURES_CODES.DASHBOARD,
        IAP_FEATURES_CODES.DEVICE_LOCK,
        IAP_FEATURES_CODES.EXPERIENCE_SCORE,
        IAP_FEATURES_CODES.FLEX_BATTERY,
        IAP_FEATURES_CODES.FLEX_PUFF,
        IAP_FEATURES_CODES.LED_INTENSITY,
        IAP_FEATURES_CODES.PAUSE_MODE,
        IAP_FEATURES_CODES.RANGE_MODE,
        IAP_FEATURES_CODES.REMEMBER_HEATING_PROFILE,
        IAP_FEATURES_CODES.SMART_GESTURES,
        IAP_FEATURES_CODES.SOFTWARE_UPDATE,
        IAP_FEATURES_CODES.SWITCH_MASTER_BADGE,
        IAP_FEATURES_CODES.TIPS_AND_TUTORIALS,
        IAP_FEATURES_CODES.TUNABILITY,
        IAP_FEATURES_CODES.USAGE,
        IAP_FEATURES_CODES.VIBRATION,
        IAP_FEATURES_CODES.VIBRATION_INTENSITY,
    ],
};
